export const getState = (state: common.RootState): common.RootState => state;

export const getDeliveryProducts = (state: common.RootState): common.DeliveriesInfo =>
  state.orderSummary.deliveriesInfo;

export const getDeliveryDetailsRequestResult = (state: common.RootState): boolean =>
  state.orderSummary.isDeliveryDetailsFailed;

export const getOrderSummaryProducts = (state: common.RootState): common.Product[] => state.orderSummary.products;

export type AnalyticData = {
  orderReference: string;
  pageLoadStart: number;
  milestones: string;
  isGeneralAPIFailed: boolean;
  errorMessage: string;
};

export const getAnalyticsData = (state: common.RootState): AnalyticData => {
  const { orderReference, orderDescription, isGeneralAPIFailed, errorMessage } = state.orderSummary;
  const { orderStatus } = state.statuses;
  const { pageLoadStart } = state.analytics;

  return {
    orderReference,
    pageLoadStart,
    milestones: `${orderStatus}:${orderDescription}`,
    isGeneralAPIFailed,
    errorMessage,
  };
};

export const getIsTrackingEventsFailed = (state: common.RootState): boolean =>
  state.orderSummary.isTrackingEventsFailed;

export const getAppointmentsInfo = (state: common.RootState): common.AppointmentsInfo =>
  state.orderSummary.appointmentsInfo;

export const getAppointmentLivePersonProps = (state: common.RootState): string => {
  const {
    orderSummary,
    aemProps: { orderTrackerSummaryProps },
  } = state;

  return orderSummary?.isCloudVoiceOrder
    ? orderTrackerSummaryProps?.lpAppointmentCveDivId
    : orderTrackerSummaryProps?.lpAppointmentGeneralDivId;
};

export const getChatQidForSummaryPage = (state: common.RootState): string => {
  const {
    orderSummary,
    aemProps: { orderTrackerSummaryProps },
  } = state;

  return orderSummary?.isCloudVoiceOrder
    ? orderTrackerSummaryProps?.lpChatCveQID
    : orderTrackerSummaryProps?.lpChatGeneralQID;
};

export const getChatQidForEntryPage = (state: common.RootState): string =>
  state.aemProps.entryLiveChatProps?.livePersonQID;

export const getAEMMobileAppTeaserProps = (state: common.RootState): common.MobileAppTeaserProps =>
  state.aemProps.mobileAppTeaserProps;

export const getAEMEntryLiveChatProps = (state: common.RootState): common.EntryLiveChatProps =>
  state.aemProps.entryLiveChatProps;

export const getAEMHeroBannerProps = (state: common.RootState): common.HeroBannerProps =>
  state.aemProps.heroBannerProps;

export const getAEMEntryFormProps = (state: common.RootState): common.EntryFormProps => state.aemProps.entryFormProps;

export const getOrderSummary = (state: common.RootState): common.OrderSummary => state.orderSummary;

export const getOrderStatusLivePersonProps = (state: common.RootState): string => {
  const {
    orderSummary,
    aemProps: { orderTrackerSummaryProps },
  } = state;

  return orderSummary?.isCloudVoiceOrder
    ? orderTrackerSummaryProps?.lpChatLinkCveDivId
    : orderTrackerSummaryProps?.lpChatLinkGeneralDivId;
};

export const getStatuses = (state: common.RootState): common.GeneralStatuses => state.statuses;

export const getIsAmendAppointmentEnabled = (state: common.RootState): boolean =>
  state.aemProps.orderTrackerSummaryProps?.isAmendAppointmentEnabled;

export const getIsAmendSiteContactEnabled = (state: common.RootState): boolean =>
  state.aemProps.orderTrackerSummaryProps?.isAmendSiteContactEnabled;

export const getAmendAppointmentInfo = (state: common.RootState): common.AmendAppointment => state.amendAppointment;

export const getAmendAppointmentModalOpened = (state: common.RootState): boolean =>
  state.amendAppointment.hasModalOpened;

export const getCurrentAppointmentInfoToAmend = (state: common.RootState): common.OrderAppointmentInfo =>
  state.amendAppointment.appointmentInfo;

export const getCurrentAppointmentDate = (state: common.RootState): string =>
  state.amendAppointment.appointmentInfo.formattedDate;

export const getCurrentAppointmentItemId = (state: common.RootState): string =>
  state.amendAppointment.appointmentInfo.itemId;

export const getSelectedAppointmentDate = (state: common.RootState): string => state.amendAppointment.selectedDate;

export const getSelectedAppointmentSlot = (state: common.RootState): string => state.amendAppointment.selectedSlot;

export const getAmendAppointmentNotificationType = (state: common.RootState): common.NotificationType =>
  state.amendAppointment.notificationType;

export const getAmendsInfo = (state: common.RootState): { [key: string]: common.AmendsInfo[] } =>
  state.amendAppointment.confirmedAmends;

export const getOrderMilestones = (state: common.RootState): common.OrderMilestone[] =>
  state.orderSummary.orderMilestones;

export const getModalInformation = (state: common.RootState): common.ModalInfo => state.modal;
